export default [
    {
        path: '/admin/first-cycle-paids',
        name: 'first-cycle-paid',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/first-cycle-paid/index.vue')
    }
]